import { SeriesValueFormatter } from '@mui/x-charts/internals';

import {
  CHARTS_OTHER_MAX_INDEX_XS,
  CHARTS_OTHERS_MAX_INDEX
} from 'utils/constants/constants';
import {
  formatMoney,
  formatMoneyWithCurrency
} from 'utils/helpers/moneyHelper';

export const mapHighlightToItems = <T>(data: T[]): T[] => {
  return data.map((item: any) => {
    return {
      ...item,
      highlightScope: { highlight: 'item', fade: 'global' }
    };
  });
};

export const dataToValueKey = <T extends { data: number }>(
  items: T[]
): (Omit<T, 'data'> & { value: number })[] =>
  items.map(({ data, ...rest }) => ({ ...rest, value: data }));

export const condenseData = (
  isXsWidth: boolean,
  data: {
    value: number;
    label: string;
  }[]
) => {
  const othersMaxIndex = isXsWidth
    ? CHARTS_OTHER_MAX_INDEX_XS
    : CHARTS_OTHERS_MAX_INDEX;
  if (data.length - 1 >= othersMaxIndex) {
    const firstPart = data.slice(0, othersMaxIndex - 1);
    const secondPart = data.slice(othersMaxIndex - 1);

    return {
      items: [
        ...firstPart,
        {
          label: '',
          value: secondPart.reduce((acc, curr) => acc + curr.value, 0)
        }
      ],
      labels: secondPart.map((item) => item.label),
      values: secondPart.map((item) => item.value)
    };
  }
  return {
    items: data,
    labels: null,
    values: null
  };
};

export const formatOthersMoney = (
  othersValues: number[] | null,
  expenses: object[]
): SeriesValueFormatter<any> => {
  return (item, { dataIndex }) => {
    if (othersValues && dataIndex === expenses!.length - 1) {
      const totalOtherValue = othersValues.reduce(
        (acc, value) => acc + value,
        0
      );
      return formatMoney(totalOtherValue);
    }
    return `${formatMoney(item.value)}`;
  };
};

export const formatOthersMoneyWithCurrency = (
  othersValues: number[] | null,
  expenses: object[],
  currency: string
): SeriesValueFormatter<any> => {
  return (item, { dataIndex }) => {
    if (othersValues && dataIndex === expenses!.length - 1) {
      const totalOtherValue = othersValues.reduce(
        (acc, value) => acc + value,
        0
      );
      return formatMoneyWithCurrency(totalOtherValue, currency);
    }
    return formatMoneyWithCurrency(item.value, currency);
  };
};
